import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import * as S from './styles'

export default function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false)
  const headerRef = useRef<HTMLDivElement>(null)
  const closeNav = () => {
    setIsNavOpen(false)
  }

  useEffect(() => {
    const onScreenClick = (e: Event) => {
      if (isNavOpen && e.target instanceof Element && !headerRef.current?.contains(e.target)) {
        closeNav()
      }
    }
    window.addEventListener('click', onScreenClick)
    return () => {
      window.removeEventListener('click', onScreenClick)
    }
  }, [isNavOpen])

  return (
    <S.DivGnbFix>
      <S.DivGnbCenter>
        <div>
          <S.DivLogoWrap>
            <Link to="/" onClick={closeNav}>
              <img src="/assets/svg/kstadium-beta-logo.svg" alt="explorer logo img" />
            </Link>
          </S.DivLogoWrap>
          <S.BesuWrap>Ground Chain Explorer</S.BesuWrap>
        </div>
        <nav ref={headerRef}>
          <S.HeaderBarIcon
            icon={faBars}
            size="xl"
            onClick={() => {
              setIsNavOpen((prevState) => !prevState)
            }}
          />
          <S.HeadeBarNav isNavOpen={isNavOpen}>
            <S.NavUl>
              <S.NavLi>
                <Link to="/" onClick={closeNav}>
                  Home
                </Link>
              </S.NavLi>
              <S.NavLiWithSUbNav>
                <S.GnbDownIcon>Blockchain</S.GnbDownIcon>
                <S.SubNavUl>
                  <S.SubNavLi>
                    <Link to="/txs" onClick={closeNav}>
                      View Txns
                    </Link>
                  </S.SubNavLi>
                  <S.SubNavLi>
                    <Link to="/blocks" onClick={closeNav}>
                      View Blocks
                    </Link>
                  </S.SubNavLi>
                  <S.SubNavLi>
                    <Link to="/accounts" onClick={closeNav}>
                      Top Accounts
                    </Link>
                  </S.SubNavLi>
                </S.SubNavUl>
              </S.NavLiWithSUbNav>
              <S.NavLi>
                <Link to="/tokens" onClick={closeNav}>
                  Tokens
                </Link>
              </S.NavLi>
            </S.NavUl>
          </S.HeadeBarNav>
          <S.UlMainMenu>
            <li>
              <Link to="/">Home</Link>
            </li>
            <S.StyledLi>
              <S.GnbDownIcon>Blockchain</S.GnbDownIcon>
              <S.DivSuvMenu>
                <ul>
                  <Link to="/txs">
                    <li>View Txns</li>
                  </Link>
                  <Link to="/blocks">
                    <li>View Blocks</li>
                  </Link>
                  <Link to="/accounts">
                    <li>Top Accounts</li>
                  </Link>
                </ul>
              </S.DivSuvMenu>
            </S.StyledLi>
            <li>
              <Link to="/tokens">Tokens</Link>
            </li>
          </S.UlMainMenu>
        </nav>
      </S.DivGnbCenter>
    </S.DivGnbFix>
  )
}
